
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
import { handleOAuthRedirectResult } from './services/authService';

// Desregistrar SW antigo e limpar caches para evitar build antiga
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((reg) => reg.unregister()));
  if ('caches' in window) {
    caches.keys().then((keys) => keys.forEach((key) => caches.delete(key)));
  }
}

const rootElement = document.getElementById('root');
if (rootElement) {
  // Processa retorno OAuth (Google/Facebook redirect) globalmente,
  // mesmo quando o modal de login não está aberto.
  handleOAuthRedirectResult().catch(() => null);

  const root = createRoot(rootElement);
  root.render(<App />);
}
